module.exports = __webpack_public_path__ + "static/media/dll.2394bad7.svg";